import Vue, {VueConstructor} from 'vue'

const EmojiHtmlMaker = (text: string): string => {
  return text
}


export default EmojiHtmlMaker;